"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFailoverOverInProgress = exports.isFailoverNotSet = exports.isFailoverConfigValid = exports.initFailoverConfig = exports.getFailoverConfigErrors = exports.failoverHasChanges = exports.NO_FAILOVER_CONFIG = void 0;
var _ipAddressValidator = require("ip-address-validator");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var INVALID_IPs = ["0.0.0.0", "127.0.0.1"];
var getFailoverConfigErrors = exports.getFailoverConfigErrors = function getFailoverConfigErrors(currentFailoverConfig, currentServerIPs) {
  if (!currentFailoverConfig) {
    return {
      failoverGroupName: false,
      failoverCurrentNode: false,
      failoverOtherIP: false,
      failoverOtherNode: false
    };
  }
  var invalidIPs = [].concat(INVALID_IPs, _toConsumableArray(currentServerIPs));
  return {
    failoverGroupName: !currentFailoverConfig.clusterID || !currentFailoverConfig.clusterID.trim(),
    failoverCurrentNode: !currentFailoverConfig.localNode.nodeID || !currentFailoverConfig.localNode.nodeID.trim() || currentFailoverConfig.localNode.nodeID === currentFailoverConfig.remoteNodes[0].nodeID,
    failoverOtherIP: !(0, _ipAddressValidator.isIPAddress)(currentFailoverConfig.remoteNodes[0].address) || invalidIPs.includes(currentFailoverConfig.remoteNodes[0].address.trim()),
    failoverOtherNode: !currentFailoverConfig.remoteNodes[0].nodeID || !currentFailoverConfig.remoteNodes[0].nodeID.trim() || currentFailoverConfig.localNode.nodeID === currentFailoverConfig.remoteNodes[0].nodeID
  };
};
var NO_FAILOVER_CONFIG = exports.NO_FAILOVER_CONFIG = {
  clusterID: "default-cluster",
  mode: "none",
  provisioningType: "none",
  localNode: {
    nodeID: "NOT_SET",
    status: "none"
  },
  remoteNodes: []
};
var initFailoverConfig = exports.initFailoverConfig = function initFailoverConfig() {
  return {
    clusterID: "",
    mode: "primary-secondary",
    provisioningType: "warm",
    localNode: {
      nodeID: "",
      status: "passive"
    },
    remoteNodes: [{
      nodeID: "",
      address: "",
      status: "active"
    }]
  };
};
var isFailoverNotSet = exports.isFailoverNotSet = function isFailoverNotSet(config) {
  return !config || !config.mode || config.mode === "none" || !config.clusterID || !config.localNode.nodeID;
};
var isFailoverOverInProgress = exports.isFailoverOverInProgress = function isFailoverOverInProgress(localStatus, clusterStatus) {
  if (!clusterStatus || !clusterStatus.clusterID || clusterStatus.clusterID === "NOT_SET") {
    return false;
  }
  var localPending = clusterStatus.localSystem.statusData.status === "active-pending" || clusterStatus.localSystem.statusData.status === "passive-pending";
  if (localStatus.remoteNodeStatus === "offline") {
    // remote node is off
    return localPending;
  }
  if (clusterStatus.remoteSystems.length < 1) {
    // remote is online, but hasn't send hello data yet
    return true;
  }
  var remotePending = clusterStatus.remoteSystems[0].statusData.status === "active-pending" || clusterStatus.remoteSystems[0].statusData.status === "passive-pending";
  if (localPending || remotePending) {
    return true;
  }
  if (clusterStatus.localSystem.statusData.status === "active" && clusterStatus.remoteSystems[0].statusData.status !== "passive") {
    return true;
  }
  return false;
};
var failoverHasChanges = exports.failoverHasChanges = function failoverHasChanges(left, right) {
  if (!left || !right) {
    return false;
  }
  return left.clusterID !== right.clusterID || left.localNode.status !== right.localNode.status || left.localNode.nodeID !== right.localNode.nodeID || left.remoteNodes[0].address !== right.remoteNodes[0].address || left.remoteNodes[0].nodeID !== right.remoteNodes[0].nodeID;
};
var isFailoverConfigValid = exports.isFailoverConfigValid = function isFailoverConfigValid(config) {
  if (!config) {
    return false;
  }
  return !!config.clusterID && (config.localNode.status === "active" || config.localNode.status === "passive") && !!config.localNode.nodeID && !!config.remoteNodes[0].address && !!config.remoteNodes[0].nodeID && config.localNode.nodeID !== config.remoteNodes[0].nodeID;
};